import Head from "next/head";
import { type ReactElement } from "react";
import { Container } from "~/components/layout/Container";
import AcceptTerms from "../components/terms/AcceptTerms";

const Terms = () => {
  return (
    <>
      <Head>
        <title>RFOX VALT | Terms</title>
      </Head>
      <Container>
        <main>
          <AcceptTerms />
        </main>
      </Container>
    </>
  );
};

Terms.getLayout = function getLayout(page: ReactElement) {
  return <>{page}</>;
};

export default Terms;
